import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, VIEW } from "const"
import { StateType, hasAccess } from "client/utils"
import {
    PRM_GROUP,
    StoreType,
    GroupProps,
    LoadGroupById,
    setGroupView,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import AccessDenied from "client/parts/accessDenied"
import Form from "./form"


const View = ({
    groupId = null,
}: GroupProps) => {
    const group = useSelector((state: StoreType) => state.group.groupView)
    const reloadView = useSelector((state: StoreType) => state.group.reloadView)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadView) return
        setLoadState(PENDING)
        LoadGroupById(groupId, userData.accountId).then((res) => {
            dispatch(setGroupView(res))
            setLoadState(IDLE)
        })
    }, [reloadView])

    const viewAccess = hasAccess(PRM_GROUP, VIEW)
    const allowedToView = viewAccess || group.creator === userData.userId

    if (!group) return <NotFound />
    if (!allowedToView) return <AccessDenied />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{`${lang.viewGroup} # ${group.id || ""}`}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <Form />
            </PageContent>
        </Container>
    )
}
export default View
